import script from "./SelectClientTypeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectClientTypeModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectClientTypeModal.vue?vue&type=style&index=0&id=bd5db19a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd5db19a"]])

export default __exports__